import React from 'react';
import { CostsProvider } from './context/CostsContext';
import { useLanguage } from './i18n';
import InputAccordion from './components/InputAccordion';
import FinancialStatements from './components/FinancialStatements';
import './App.css';

function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="language-switcher">
      <button
        className={language === 'en' ? 'active' : ''}
        onClick={() => setLanguage('en')}
      >
        EN
      </button>
      <button
        className={language === 'de' ? 'active' : ''}
        onClick={() => setLanguage('de')}
      >
        DE
      </button>
    </div>
  );
}

function App() {
  const { t } = useLanguage();

  return (
    <CostsProvider>
      <div className="app-container">
        <header className="app-header">
          <div className="header-content">
            <h1>{t('app.title')}</h1>
            <p className="subtitle">{t('app.subtitle')}</p>
          </div>
          <LanguageSwitcher />
        </header>

        <div className="disclaimer-banner">{t('app.banner')}</div>

        <div className="main-content">
          <div className="input-section">
            <h2>{t('app.inputParameters')}</h2>
            <InputAccordion />
          </div>

          <div className="statements-section">
            <h2>{t('app.financialProjections')}</h2>
            <FinancialStatements />
          </div>
        </div>

        <footer className="app-footer">
          <p>{t('app.disclaimer')}</p>
        </footer>
      </div>
    </CostsProvider>
  );
}

export default App;
